// extracted by mini-css-extract-plugin
export default {"customSelect":"menu_customSelect__c6ZRs","smallFont":"menu_smallFont__0fBwp","productLink":"menu_productLink__aBzCS","show":"menu_show__+O9YX","hide":"menu_hide__85NOE"};